import $ from "jquery";

export default class Menu {
    constructor() {
        this.body = document.querySelector('body');

        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.lang = {
            toggler: document.querySelector('#select-language .dropdown-toggler'),
            menu: document.querySelector('#select-language .dropdown-menu'),
        }

        this.page = {
            title: document.getElementById('page-title'),
            header: document.querySelector('header.header'),
            company: document.getElementById('company'),
        }
    }

    init() {
        this.toggle();
        // if(Sniff.browser.name != 'chrome' && !Sniff.features.mobile){ this.manipulate(); }
        if(!Sniff.features.mobile){ this.language(); }
    }

    toggle = () => {
        this.menu.toggler.addEventListener('click', () => {
            this.menu.main.classList.toggle('active');
            this.menu.toggler.classList.toggle('active');
            this.body.classList.toggle('overflow-hidden');
            if(this.lang.toggler){
                this.lang.menu.classList.remove('show');
            }
            this.page.title.classList.toggle('active');
            this.page.company.classList.toggle('active');
            if(!this.page.company.classList.contains('visible')){
                this.page.company.classList.add('visible');
            } else if(!this.menu.main.classList.contains('active')){
                this.page.company.classList.remove('visible');
            }
        });
    }

    manipulate = () =>{
        this.page.company.style.bottom = this.page.header.clientHeight + 'px';
    }

    language = () => {
        if(this.lang.toggler){
            this.lang.toggler.addEventListener('click', () => {
                this.lang.menu.classList.toggle('show');
            });
        }
    }
}
